var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "grey-f8",
    attrs: {
      "rounded": "lg",
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-30 pa-lg-40"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('recruitment-list-search-filter')], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "input--search"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "주소, 회사명, 공고명, 키워드로 검색해주세요",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event);
      }
    },
    model: {
      value: _vm.query.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "searchValue", $$v);
      },
      expression: "query.searchValue"
    }
  }), _c('v-btn', {
    staticClass: "transparent",
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "icon icon-search-black"
  })])], 1)])], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }